/* eslint-disable react-hooks/exhaustive-deps */
import { selectSalaryPermission } from "@lhd/app/slices";
import { AvtDefault, Logout } from "@lhd/assets";
import { CONTRACT_STATUS_ACCEPTED } from "@lhd/components/SideBar/constants";
import { PAGE_PATHS, ROUTES, SETTING_CATEGORY_FROM } from "@lhd/constants";
import { projectTabTitleMap } from "@lhd/features/ProjectManager/constants/project";
import { useFetchBizProject } from "@lhd/features/ProjectManager/ProjectMgmtMain/hook";
import { COMPANY_DETAIL_TABS } from "@lhd/features/UserCompanies/CompanyDetail/utility";
import { user } from "@lhd/features/users/selector";
import {
  useFetchOneApp,
  useFetchOneProject,
  useFetchOrgs,
  useFetchSettingSize,
  useGetAuth,
  useGetCourseDetail,
  useGetPermissions,
  useLogout,
} from "@lhd/hooks";
import { Company } from "@lhd/types";
import {
  getBusinessRpgPlayLabel,
  getCompanyId,
  getTabTitle,
} from "@lhd/utility";
import { Button as ButtonAntd, Popover, Tooltip } from "antd";
import { get, isEmpty, size, toString } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { isMobileOnly } from "react-device-detect";
import { AiOutlineCaretRight } from "react-icons/ai";
import { IoMdArrowDropright } from "react-icons/io";
import { RiArrowDownSFill, RiBuildingFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Button from "../Button";
import { setIsMobileMenuOpen } from "../CommonLayout/sidebarSlice";
import DisplaySizeSelector from "../DisplaySizeSelector";
import { setDisplaySize } from "../DisplaySizeSelector/displaySizeSlice";
import { formatCompanyName } from "../SideBar";
import ModalSelectEdit from "./ModalSelectEdit";
import { CompanyNameWrapper, Container, Styles } from "./styled";

type IProps = {
  isCollapse: boolean;
};
type BreadcrumbItem = {
  title?: string;
  url?: string;
  isShowIcon?: boolean;
};

type Props = {
  pathname: string;
  tab?: string | null;
  pageMode?: string | null;
};

export const getShowDisplaySizeSelector = ({
  pathname,
  tab,
  pageMode,
}: Props): boolean => {
  return (
    ((/^\/performance_appraisal\/appraisals\/\d+$/.test(pathname) ||
      pathname === "/performance_appraisal/appraisals/create") &&
      (tab === "qualitative" || tab === "quantitative" || tab === "setting")) ||
    (/^\/customers\/\d+$/.test(pathname) &&
      (tab === "registration_information" ||
        tab === "general_management_information" ||
        tab === "contract_information")) ||
    (/^\/customers\/customer_sheets$/.test(pathname) &&
      [
        "registration_information",
        "general_management_information",
        "contract_information",
      ].includes(tab || "")) ||
    (/^\/performance_appraisal\/appraisal_sheets\/\d+$/.test(pathname) &&
      tab === "qualitative") ||
    (/^\/performance_appraisal\/appraisal_sheets\/\d+$/.test(pathname) &&
      tab === "quantitative") ||
    PAGE_PATHS.some((path) => pathname === path) ||
    /^\/apps\/\d+\/records$/.test(pathname) ||
    /^\/apps\/\d+\/records(?:\/edit(?:\/\d+)?)?$/.test(pathname) ||
    /^\/apps\/\d+\/app-information$/.test(pathname) ||
    /^\/apps\/\d+\/app-table$/.test(pathname) ||
    /^\/apps\/\d+\/app-grid$/.test(pathname) ||
    /^\/apps\/\d+\/permission$/.test(pathname) ||
    /^\/apps\/\d+\/records\/app-sheets$/.test(pathname) ||
    /^\/organizational-chart/.test(pathname) ||
    (pathname === "/apps/create" &&
      ["app-information", "app-table", "app-grid", "permission"].includes(
        tab || "",
      )) ||
    /^\/workers$/.test(pathname) ||
    /^\/organizational-chart\/(create|\d+)$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/staff_tax_sheets$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/payment_sheets$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/salary_sheets$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/provisions$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/expenses$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/transfers$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/deductions$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/works$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/arrangements$/.test(pathname) ||
    /^\/annual_salary_summaries\/\d{4}\/salary_sheet_for_workers$/.test(
      pathname,
    ) ||
    (/^\/e-learning\/course\/\d+$/.test(pathname) && tab === "lesson_list") ||
    (/^\/e-learning\/course\/\d+$/.test(pathname) && tab === "lesson_detail") ||
    (/^\/e-learning\/course\/\d+$/.test(pathname) && tab === "history") ||
    pathname === "/performance_appraisal/appraisal_kgi_list" ||
    pathname === "/performance_appraisal/config" ||
    /^\/e-learning\/courses\/\d+\/edit$/.test(pathname) ||
    /^\/customers(\/\d+)?$/.test(pathname) ||
    /^\/company_configuration(\/\d+)?$/.test(pathname) ||
    pathname === "/company_policies" ||
    pathname === "/role_permissions" ||
    /^\/companies(\/\d+)?$/.test(pathname) ||
    /^\/workers(\/\d+)?$/.test(pathname) ||
    (pathname === "/admin/config" &&
      [
        "workers",
        "biz_sheet",
        "customer",
        "project_management",
        "appraisals",
        "appraisal_sheets",
        "business_trip_reports",
      ].includes(tab || "")) ||
    /^\/app_categories\/\d+$/.test(pathname) ||
    /^\/role_permissions\/\d+\/edit\/\d+$/.test(pathname) ||
    /^\/role_permissions\/\d+\/create$/.test(pathname) ||
    /^\/maintenance_notification\/\d+$/.test(pathname) ||
    pathname === "/business_trip_reports" ||
    /^\/financial_reports\/\d+\/create$/.test(pathname) ||
    /^\/financial_reports\/\d+\/edit\/\d+$/.test(pathname) ||
    /^\/employment_contracts\/\d+\/create\/\d+$/.test(pathname) ||
    /^\/employment_contracts\/\d+\/edit\/\d+\/\d+$/.test(pathname) ||
    /^\/agreements\/\d+\/create\/\d+$/.test(pathname) ||
    /^\/agreements\/\d+\/edit\/\d+\/\d+$/.test(pathname) ||
    /^\/labor_documents\/\d+\/create\/\d+$/.test(pathname) ||
    /^\/labor_documents\/\d+\/edit\/\d+\/\d+$/.test(pathname) ||
    /^\/company_policies\/\d+\/create$/.test(pathname) ||
    /^\/company_policies\/\d+\/edit\/\d+$/.test(pathname) ||
    /^\/business_flow\/\d+\/create$/.test(pathname) ||
    /^\/business_flow\/\d+\/edit\/\d+$/.test(pathname) ||
    pathname === "/business_flow" ||
    /^\/business_manuals\/\d+\/create$/.test(pathname) ||
    /^\/business_manuals\/\d+\/edit\/\d+$/.test(pathname) ||
    pathname === "/business_manuals"
  );
};

const Header = ({ isCollapse }: IProps) => {
  const location = useLocation();
  const { handleLogout } = useLogout();
  const { isUserResigned, auth } = useGetAuth();
  const workers: any = get(auth, "workers[0]", null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const match = useMatch("/orgs/:id");
  const org_id = match?.params.id;
  const [searchParams] = useSearchParams();
  const { data: listOrg } = useFetchOrgs(
    undefined,
    undefined,
    undefined,
    !match,
  );
  const patchName = location.pathname.split("/");
  const shouldHideELearningListBreadcrumb =
    searchParams.get("fromChart") === "true" &&
    patchName?.[2] === ROUTES.COURSES &&
    patchName?.[3] === ROUTES.CREATE;
  const courseBreadcrumbSearchParams = new URLSearchParams(searchParams);
  courseBreadcrumbSearchParams.set("tab", "lesson_list");
  const courseId =
    patchName?.[1] === ROUTES.Electronic_Learning &&
    patchName?.[3] &&
    patchName?.[3] !== ROUTES.CREATE &&
    patchName?.[3] !== ROUTES.EDIT
      ? toString(patchName?.[3])
      : "";
  const { data: courseData } = useGetCourseDetail(courseId);
  const course_detail_name = courseData?.data?.title;
  const isPMDetailRoute =
    patchName?.[1] === ROUTES.PROJECT_MANAGER && !!patchName?.[2];
  const { data: projectDetailData } = useFetchBizProject(
    isPMDetailRoute ? toString(patchName[2]) : undefined,
  );
  const wrapRef = useRef<HTMLDivElement>(null);
  // const salaryConfigs = useSalaryPermission();
  const salaryConfigs = { data: useSelector(selectSalaryPermission) };
  const isAdmin = get(auth, "is_admin", false);
  const currentCompanyLogin = auth?.companies?.find(
    (i: Company) => Number(i?.id) === Number(getCompanyId()),
  );
  const isRootCompany = currentCompanyLogin?.is_root_company;
  const isContractStatusAccepted = CONTRACT_STATUS_ACCEPTED.includes(
    auth?.current_contract_status as typeof CONTRACT_STATUS_ACCEPTED[number],
  );
  const hasCompanyAdminContext =
    isAdmin &&
    (currentCompanyLogin?.is_admin || isRootCompany) &&
    isContractStatusAccepted;

  const orgName = listOrg?.data.find((data) => data.id == org_id)?.name;
  const { data: appDetail } = useFetchOneApp(
    patchName[1] === ROUTES.APPS && !Number.isNaN(Number(patchName?.[2]))
      ? Number(patchName?.[2])
      : undefined,
  );

  const { data: projectData } = useFetchOneProject(
    patchName[1] === ROUTES.PROJECT_MANAGE &&
      !Number.isNaN(Number(patchName?.[2]))
      ? Number(patchName?.[2])
      : undefined,
  );

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  // const [isNotificationOpen, setIsNotificationOpen] = useState<boolean>(false);

  const handleCancelModal = () => setIsOpenModal(false);

  const handleOpenModal = () => setIsOpenModal(true);

  // const handleNotificationOpenChange = (open: boolean) => {
  //   setIsNotificationOpen(open);
  // };

  const navigateToCompanyConfig = () =>
    navigate(`/${ROUTES.COMPANY_CONFIGURATION}`);

  const closeCurrentTab = () => {
    window && window.close();
  };

  const companyId = getCompanyId();
  const permission = useGetPermissions();
  const matchCompanyConfig = useMatch({
    path: ROUTES.COMPANY_CONFIGURATION,
    end: false,
  });

  const contentMenuRightHeader = (
    <div className="menu-right-header">
      <div className="right-header-item">
        <div className="right-header-content">
          <div className="right-header-content-text">
            <div className="wrap-icon">
              <AiOutlineCaretRight color="rgba(141, 141, 141, 1)" size={24} />
            </div>
            <span className="right-header-content-email">
              {workers?.full_name || ""} {workers?.user?.email || ""}
            </span>
          </div>
        </div>
        <div
          className="cursor-pointer d-flex justify-center align-item-center"
          onClick={handleLogout}
        >
          <Logout />
        </div>
      </div>
    </div>
  );

  const handleTitleAnnualSalary = () => {
    switch (patchName[3]) {
      case ROUTES.SALARY_SHEETS:
        return "給与明細";
      case ROUTES.SALARY_LEDGERS:
        return "賃金台帳";
      case ROUTES.SALARY_SHEET_FOR_WORKERS:
        return "支給控除一覧";
      case ROUTES.STAFF_TAX_SHEETS:
        return "スタッフデータ";
      case ROUTES.PAYMENT_SHEETS:
        return "支払計算書";
      case ROUTES.TRANSFERS:
        return "振込";
      case ROUTES.PROVISIONS:
        return "支給";
      case ROUTES.EXPENSES:
        return "経費精算";
      case ROUTES.WORKS:
        return "勤務";
      case ROUTES.ARRANGEMENTS:
        return "年末調整";
      case ROUTES.DEDUCTIONS:
        return "控除";

      default:
        return null;
    }
  };

  const getTitleSalaryList = (route: string) => {
    switch (route) {
      case ROUTES.SALARY_SHEETS:
      case ROUTES.PAYMENT_SHEETS:
        return "給与明細";
      case ROUTES.ANNUAL_PAYMENT_LIST:
        return "支払計算書一覧";
      case ROUTES.ANNUAL_SALARY_LIST:
        return "給与明細 一覧";
      default:
        return `${route}年`;
    }
  };

  const handleTitleAppraisal = () => {
    const patchString = `${patchName[1]}/${patchName[2]}`;
    switch (patchString) {
      case ROUTES.APPRAISAL_LIST:
        return "目標一覧";
      case ROUTES.APPRAISAL_SHEET_LIST:
        return "評価シート一覧";
      case ROUTES.APPRAISAL_SETTING:
        return "人事評価設定";
      case ROUTES.APPRAISAL_ANALYST:
        return "評価結果分析";
      case ROUTES.APPRAISAL_KGI_LIST:
        return "行動目標一覧";
      default:
        return "";
    }
  };

  const listBreadCumb = () => {
    const defaultBreadcrumb: BreadcrumbItem = {
      title: "階層パス",
      isShowIcon: true,
    };

    const getBreadcrumbItems = () => {
      let listArrBreadCumb: BreadcrumbItem[] = [];

      const getSettingCategoriesBreadcrumb = (
        fromParam: string,
        typeParam: string | null,
        yearParam: string | null,
        isSettingRoute: boolean,
      ) => {
        const baseEditStr =
          typeParam === "category" ? "カテゴリー編集" : "ステータス編集";
        const baseEditObj = isSettingRoute
          ? { title: baseEditStr }
          : {
              title: baseEditStr,
              url: `/${
                ROUTES.SETTING_CATEGORIES
              }?type=${typeParam}&from=${fromParam}${
                yearParam ? `&year=${yearParam}` : ""
              }`,
            };

        const orgUrl = `/${ROUTES.ANNUAL_ORG_SUMMARIES}`;
        const suffix = isSettingRoute ? [] : [{ title: "設定" }];

        if (fromParam === SETTING_CATEGORY_FROM.WORKER_CREATE) {
          return [
            { title: "人事/組織", url: orgUrl },
            {
              title: "＋スタッフ新規",
              url: `/${ROUTES.WORKERS}/${ROUTES.CREATE}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.WORKER_LIST) {
          return [
            { title: "人事/組織", url: orgUrl },
            { title: "スタッフ一覧", url: `/${ROUTES.WORKERS}` },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.STAFF_TAX_SHEET) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "スタッフデータ",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/${ROUTES.STAFF_TAX_SHEETS}?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.PROVISIONS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "支給",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/provisions?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.DEDUCTIONS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "控除",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/deductions?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.WORKS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "勤務",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/works?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.EXPENSES) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "経費精算",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/expenses?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.BUSINESS_TRIP_REPORTS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "承認 旅費入力",
              url: `/${
                ROUTES.BUSINESS_TRIP_REPORTS
              }?isDisplayInNewTab=true&view_type=approval${
                yearParam ? `&year=${yearParam}` : ""
              }`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.TRANSFER) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "振込",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/transfers?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.ARRANGEMENTS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "年末調整",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/arrangements?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.SALARY_SHEETS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "給与明細",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/salary_sheets?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.PAYMENT_SHEETS) {
          return [
            {
              title: "給与明細/支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
            },
            {
              title: `${yearParam || new Date().getFullYear()}年`,
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}?isDisplayInNewTab=true`,
            },
            {
              title: "支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${
                yearParam || new Date().getFullYear()
              }/payment_sheets?isDisplayInNewTab=true`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.PROJECT_MANAGER) {
          return [
            {
              title: "プロジェクト管理",
              url: `/${ROUTES.PROJECT_MANAGER_LIST}`,
            },
            {
              title: "プロジェクト一覧",
              url: `/${ROUTES.PROJECT_MANAGER_LIST}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.LIST_MESS) {
          return [
            {
              title: "カスタマー問合せ",
              url: `/${ROUTES.LIST_MESS}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.COMPANY_POLICIES) {
          return [
            {
              title: "社内規定・就業規則",
              url: `/${ROUTES.COMPANY_POLICIES}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.CLIENT) {
          return [
            {
              title: "顧客一覧",
              url: `/${ROUTES.CUSTOMER_LIST}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        if (fromParam === SETTING_CATEGORY_FROM.BUSINESS_MANUALS) {
          return [
            {
              title: "内部統制",
            },
            {
              title: "業務マニュアル",
              url: `/${ROUTES.BUSINESS_MANUALS}`,
            },
            baseEditObj,
            ...suffix,
          ];
        }
        return null;
      };

      const tabParamsApp = searchParams.get("tab");
      const pmDetailTabParams = searchParams.get("pmtab");
      const isAtPmChartView = searchParams.get("pmview") === "chart";
      const viewTypeBusinessReportTrip = searchParams.get("view_type");
      const yearSelected = searchParams.get("year");
      const permissions = !isEmpty([
        ...(salaryConfigs.data?.salary_edit || []),
        ...(salaryConfigs.data?.salary_view || []),
        ...(salaryConfigs.data?.salary_delete || []),
      ]);

      switch (patchName[1]) {
        case ROUTES.TRACKING_TIME_RAW:
          listArrBreadCumb = [
            {
              title: "勤怠アプリ",
              url: ROUTES.TRACKING_TIME,
            },
          ];
          if (patchName[2] === ROUTES.LIST.replace(/^\//, "")) {
            listArrBreadCumb.push({
              title: "勤怠管理",
              url: location.pathname,
            });
          }
          return listArrBreadCumb;
        case ROUTES.APPRAISAL_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "人事評価",
              url: `/${ROUTES.APPRAISAL_SUMMARIES}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.CUSTOMER_LIST:
          listArrBreadCumb = [
            {
              title: "取引先一覧",
              url: `/${ROUTES.CUSTOMER_LIST}`,
              isShowIcon: patchName?.[2] === ROUTES.CREATE,
            },
            {
              ...(patchName?.[2] === ROUTES.CREATE && {
                title: "＋ 取引先 新規",
                url: `/${ROUTES.CUSTOMER_LIST}/${ROUTES.CREATE}`,
              }),
            },
          ];
          return listArrBreadCumb;
        case ROUTES.COMPANY_POLICIES:
        case ROUTES.COMPANY_POLICIES_CHART:
          if (
            patchName?.[3] === ROUTES.CREATE &&
            searchParams.get("from") === ROUTES.COMPANY_POLICIES_CHART
          ) {
            listArrBreadCumb = [
              {
                title: "社内規定・就業規則",
                url: `/${ROUTES.COMPANY_POLICIES_CHART}`,
              },
              {
                title: "＋規程新規",
              },
            ];
            return listArrBreadCumb;
          }
          if (
            patchName?.[1] === ROUTES.COMPANY_POLICIES &&
            patchName?.[3] === ROUTES.CREATE
          ) {
            listArrBreadCumb = [
              {
                title: "社内規定・就業規則",
                url: `/${ROUTES.COMPANY_POLICIES_CHART}`,
              },
              {
                title: "規程一覧",
                url: `/${ROUTES.COMPANY_POLICIES}`,
              },
              {
                title: "規程新規",
              },
            ];
            return listArrBreadCumb;
          }
          if (patchName?.[1] === ROUTES.COMPANY_POLICIES && !patchName?.[2]) {
            listArrBreadCumb = [
              {
                title: "社内規定・就業規則",
                url: `/${ROUTES.COMPANY_POLICIES_CHART}`,
              },
              {
                title: "規程一覧",
              },
            ];
            return listArrBreadCumb;
          }
          listArrBreadCumb = [
            {
              title: "社内規定・就業規則",
              url: `/${ROUTES.COMPANY_POLICIES_CHART}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.ROLE_PERMISSIONS:
          if (
            patchName?.[3] === ROUTES.CREATE &&
            searchParams.get("from") === ROUTES.BUSINESS_CONTROLS_CHART
          ) {
            listArrBreadCumb = [
              {
                title: "内部統制",
                url: `/${ROUTES.BUSINESS_CONTROLS_CHART}`,
              },
              {
                title: "職務権限マトリクス新規",
              },
            ];
          } else {
            listArrBreadCumb = [
              {
                title: "内部統制",
                url: `/${ROUTES.ROLE_PERMISSIONS}`,
              },
            ];
          }
          return listArrBreadCumb;
        case ROUTES.BUSINESS_CONTROLS_CHART:
          listArrBreadCumb = [
            {
              title: "内部統制",
              url: `/${ROUTES.BUSINESS_CONTROLS_CHART}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.BUSINESS_FLOW:
          listArrBreadCumb = [
            {
              title: "業務フロー",
              url: `/${ROUTES.BUSINESS_FLOW}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.BUSINESS_MANUALS: {
          const isCreate = patchName?.[3] === ROUTES.CREATE;

          listArrBreadCumb = [
            {
              title: "内部統制",
              url: `/${ROUTES.BUSINESS_MANUALS}`,
            },
            {
              title: isCreate ? "業務マニュアル新規" : "業務マニュアル",
            },
          ];

          return listArrBreadCumb;
        }

        case ROUTES.PROJECT_MANAGE:
          listArrBreadCumb = [
            {
              title: "プロジェクト管理（β版）",
              url: `/${ROUTES.PROJECT_MANAGE}`,
            },
          ];
          if (
            patchName?.[2] &&
            patchName?.[2] &&
            !Number.isNaN(Number(patchName?.[2]))
          ) {
            listArrBreadCumb.push({ title: projectData?.name });
          }
          return listArrBreadCumb;
        case ROUTES.BIZ_SHEET_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "Bizシート",
              url: `/${ROUTES.BIZ_SHEET_SUMMARIES}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.LEGACY_EVENT_FORMS:
        case ROUTES.EVENT_FORMS:
          listArrBreadCumb = [
            {
              title: "Bizフォーム",
              url: `/${ROUTES.EVENT_FORMS}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.APPS:
          listArrBreadCumb = [
            {
              title: "Bizシート",
              url: `/${ROUTES.APPS}`,
            },
          ];

          if (patchName?.[2] === ROUTES.CREATE) {
            listArrBreadCumb.push({
              title: "新規追加",
            });
          } else if (patchName?.[2] === ROUTES.PERMISSION) {
            listArrBreadCumb.push({
              title: "設定",
            });
          } else if (tabParamsApp === "list-app") {
            listArrBreadCumb.push({
              title: "Bizシート一覧",
            });
          } else if (tabParamsApp === "store-app") {
            listArrBreadCumb.push({
              title: "Bizシートストア",
            });
          } else if (tabParamsApp === "app-permissions") {
            listArrBreadCumb.push({
              title: "Bizシート",
            });
          } else {
            if (patchName?.[2]) {
              listArrBreadCumb.push({
                title: appDetail?.name,
              });
            }
          }
          return listArrBreadCumb;
        case ROUTES.SETTING_PRIVILEGE:
          listArrBreadCumb = [
            {
              title: "業務/販売",
              url: `/${ROUTES.CUSTOMER_LIST}`,
            },
            {
              title: "Bizシート",
              url: `/${ROUTES.APPS}`,
            },
            {
              title: "Bizシート権限",
            },
          ];
          return listArrBreadCumb;
        case ROUTES.AUTH:
          if (patchName.includes(ROUTES.USERS)) {
            listArrBreadCumb = [
              {
                title: "人事・組織",
                url: `/${ROUTES.WORKERS}`,
              },
              {
                title: "スタッフ一覧",
              },
              {
                title: "ログイン情報",
                url: `/${ROUTES.AUTH}/${ROUTES.USERS}`,
              },
            ];
          } else if (patchName.includes(ROUTES.WORKERS)) {
            listArrBreadCumb = [
              {
                title: "人事・組織",
                url: `/${ROUTES.WORKERS}`,
              },
              {
                title: "スタッフ一覧",
              },
              {
                title: "社員情報",
                url: `/${ROUTES.AUTH}/${ROUTES.WORKERS}`,
              },
            ];
          }
          return listArrBreadCumb;
        case ROUTES.WORKERS:
          listArrBreadCumb = [
            {
              title: "人事・組織",
              url: `/${ROUTES.ANNUAL_ORG_SUMMARIES}`,
            },
            {
              ...(patchName?.[2] === ROUTES.CREATE
                ? {
                    title: "＋スタッフ新規",
                    url: `/${ROUTES.WORKERS}/${ROUTES.CREATE}`,
                  }
                : {
                    title: "スタッフ一覧",
                    url: `/${ROUTES.WORKERS}`,
                  }),
            },
          ];
          return listArrBreadCumb;
        case ROUTES.ANNUAL_ORG_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "人事・組織",
              isShowIcon: !!patchName[2],
            },
            {
              ...(patchName?.[2] === ROUTES.WORKER_INVITE_CHART && {
                title: "スタッフ招待",
                url: `/${ROUTES.WORKER_INVITE_CHART}`,
              }),
            },
          ];
          return listArrBreadCumb;
        case ROUTES.CUSTOMER_HISTORY_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "取引先情報",
              url: `/${ROUTES.CUSTOMER_HISTORY_SUMMARIES}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.AGENT_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "代理店",
              url: `/${ROUTES.AGENT_SUMMARIES}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.PERMISSION_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "権限管理",
            },
          ];
          return listArrBreadCumb;
        case ROUTES.USERS:
          listArrBreadCumb = [
            {
              title: "人事・組織",
              url: `/${ROUTES.ANNUAL_ORG_SUMMARIES}`,
            },
            // {
            //   title: "ログインユーザー",
            //   url: `/${ROUTES.USERS}`,
            // },
          ];
          return listArrBreadCumb;

        case ROUTES.COMPANY_CONFIGURATION:
          listArrBreadCumb = [
            {
              title: "企業情報",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.BRANCH:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "支店",
              url: `/${ROUTES.BRANCH}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.ORGANIZATIONS:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "組織",
              url: `/${ROUTES.ORGANIZATIONS}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.ORGS:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: orgName,
              url: `/${ROUTES.ORGS}/${org_id}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.DEPARTMENTS:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "部門",
              url: `/${ROUTES.DEPARTMENTS}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.MANAGEMENT:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "経営層",
              url: `/${ROUTES.MANAGEMENT}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.DIVISIONS:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "部署",
              url: `/${ROUTES.DIVISIONS}`,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ANNUAL_SALARY_SUMMARIES:
          if (
            patchName[2] === ROUTES.SALARY_LEDGERS ||
            patchName[3] === ROUTES.SALARY_LEDGERS
          ) {
            listArrBreadCumb = [
              {
                title: "給与明細・支払計算書",
                url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
                isShowIcon: true,
              },
              {
                title: "賃金台帳",
                isShowIcon: false,
              },
            ];
            return listArrBreadCumb;
          }

          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
              isShowIcon: !!patchName[2],
            },
            {
              ...(patchName[2] && {
                title: getTitleSalaryList(patchName[2]),
                url: `${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
              }),
              isShowIcon: !!handleTitleAnnualSalary(),
            },
            {
              ...(handleTitleAnnualSalary() && {
                title: `${handleTitleAnnualSalary()}`,
                url: location.pathname,
              }),
            },
          ];
          return listArrBreadCumb;

        case ROUTES.SALARY_CONFIGURATION:
          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
              isShowIcon: true,
            },
            {
              title: "給与／支払設定",
              isShowIcon: false,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.BUSINESS_TRIP_REPORTS:
          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
              isShowIcon: true,
            },
            {
              ...(yearSelected && {
                title: `${yearSelected + "年"}`,
                url: `${ROUTES.ANNUAL_SALARY_SUMMARIES}`,
              }),
              isShowIcon: false,
            },
            {
              title:
                viewTypeBusinessReportTrip === "owner"
                  ? "旅費規程入力"
                  : "承認 旅費入力",
              isShowIcon: false,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ANNUAL_PAYMENT_SUMMARIES:
          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.PAYSLIP}`,
              isShowIcon: true,
            },
            {
              title: "支払計算書管理",
              url: `/${ROUTES.ANNUAL_PAYMENT_SUMMARIES}`,
              isShowIcon: !!patchName[2],
            },
            {
              ...(patchName[2] && {
                title: `${
                  patchName[2] === ROUTES.SALARY_SHEETS
                    ? "給与明細"
                    : patchName[2] + "年"
                }`,
                url: `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${patchName[2]}`,
              }),
              isShowIcon: !!handleTitleAnnualSalary(),
            },
            {
              ...(handleTitleAnnualSalary() && {
                title: `${handleTitleAnnualSalary()}`,
                url: location.pathname,
              }),
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ANNUAL_SALARY_LIST:
          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.ANNUAL_SALARY_LIST}`,
              isShowIcon: true,
            },
            {
              title: "給与明細",
              // url: `/${ROUTES.ANNUAL_SALARY_LIST}`,
              isShowIcon: false,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ANNUAL_PAYMENT_LIST:
          listArrBreadCumb = [
            {
              title: "給与明細・支払計算書",
              url: `/${ROUTES.ANNUAL_PAYMENT_LIST}`,
              isShowIcon: true,
            },
            {
              title: "支払計算書",
              // url: `/${ROUTES.ANNUAL_SALARY_LIST}`,
              isShowIcon: false,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.COMPANIES:
          listArrBreadCumb = [
            {
              title:
                patchName?.[2] === ROUTES.CREATE && isDisplayInNewTab
                  ? "契約管理"
                  : "運営",
              url:
                patchName?.[2] === ROUTES.CREATE && isDisplayInNewTab
                  ? `/${ROUTES.CONTRACT_MANAGEMENT}`
                  : hasCompanyAdminContext
                  ? `/${ROUTES.COMPANIES}`
                  : undefined,
            },
            {
              title:
                patchName?.[2] === ROUTES.CREATE && isDisplayInNewTab
                  ? "企業アカウント作成"
                  : "契約会社",
              url: `/${ROUTES.COMPANIES}`,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.PERFORMANCE_APPRAISAL:
          listArrBreadCumb = [
            {
              title: "人事評価",
              url: `/${ROUTES.APPRAISAL_LIST}`,
            },
            {
              title: handleTitleAppraisal(),
            },
          ];
          return listArrBreadCumb;

        case ROUTES.APPRAISAL_SETTING:
          listArrBreadCumb = [
            {
              title: "人事評価",
              url: `/${ROUTES.APPRAISAL_LIST}`,
            },
            {
              title: "人事評価設定",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.APPRAISAL_ANALYST:
          listArrBreadCumb = [
            {
              title: "人事評価",
              url: `/${ROUTES.APPRAISAL_LIST}`,
            },
            {
              title: "評価結果分析",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.APPRAISAL_KGI_LIST:
          listArrBreadCumb = [
            {
              title: "人事評価",
              url: `/${ROUTES.APPRAISAL_LIST}`,
            },
            {
              title: "行動目標一覧",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ORGANIZATION_MANAGEMENT:
          listArrBreadCumb = [
            {
              title: "権限管理",
              url: `/${ROUTES.COMPANY_CONFIGURATION}`,
            },
            {
              title: "組織マスタ管理",
              url: `/${ROUTES.ORGANIZATION_MANAGEMENT}`,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.APP_CATEGORIES:
          listArrBreadCumb = [
            {
              title: "運営",
              url: hasCompanyAdminContext ? `/${ROUTES.COMPANIES}` : undefined,
            },
            {
              title: "ストアカテゴリ",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.APP_SUBMITTED_MANAGEMENT:
          listArrBreadCumb = [
            {
              title: "運営",
              url: hasCompanyAdminContext ? `/${ROUTES.COMPANIES}` : undefined,
            },
            {
              title: "ストア承認管理",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.POSITIONS:
          listArrBreadCumb = [
            {
              title: "組織管理",
              url: `/${ROUTES.POSITIONS}`,
            },
            {
              title: "役職一覧",
              url: `/${ROUTES.POSITIONS}`,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ORGANIZATION_CHART:
          listArrBreadCumb = [
            {
              title: "人事・組織",
              url: `/${ROUTES.ANNUAL_ORG_SUMMARIES}`,
            },
            {
              title: "組織図",
              url: `/${ROUTES.ORGANIZATION_CHART}`,
            },
          ];
          return listArrBreadCumb;

        case ROUTES.PERMISSIONS_MANAGEMENT:
          listArrBreadCumb = [
            {
              title: "権限管理",
              //url: `/${ROUTES.COMPANY_CONFIGURATION}`,
            },
            {
              title: "権限設定",
              // url: `/${ROUTES.PERMISSIONS_SALARY}`,
            },
          ];
          if (tabParamsApp === "app_permissions") {
            listArrBreadCumb.push({
              title: "Bizシート",
            });
          } else if (tabParamsApp === "salary_permissions") {
            listArrBreadCumb.push({
              title: "給与明細",
            });
          } else if (tabParamsApp === "appraisal_permissions") {
            listArrBreadCumb.push({
              title: "人事評価",
            });
          } else if (tabParamsApp === "e_learning_permissions") {
            listArrBreadCumb.push({
              title: "Eラーニング",
            });
          } else if (tabParamsApp === "company_permissions") {
            listArrBreadCumb.push({
              title: "企業基礎情報",
            });
          } else if (tabParamsApp === "worker_permissions") {
            listArrBreadCumb.push({
              title: "社員一覧",
            });
          } else if (tabParamsApp === "company_policies_permissions") {
            listArrBreadCumb.push({
              title: "就業規則/規程",
            });
          } else if (tabParamsApp === "tracking_permissions") {
            listArrBreadCumb.push({
              title: "勤怠アプリ",
            });
          } else if (tabParamsApp === "role_permissions") {
            listArrBreadCumb.push({
              title: "内部統制",
            });
          }

          return listArrBreadCumb;

        case ROUTES.Electronic_Learning:
          listArrBreadCumb = [
            {
              title: "Eラーニング",
              url: `/${ROUTES.ELECTRONIC_LEARNING_CHART}`,
            },
          ];
          if (patchName?.[2]) {
            if (patchName[2] === ROUTES.STORE) {
              listArrBreadCumb.push({
                title: "Eラーニングストア",
              });
            } else if (!shouldHideELearningListBreadcrumb) {
              listArrBreadCumb.push({
                title: "Eラーニング一覧",
                url: `/${ROUTES.Electronic_Learning}`,
              });
            }
          } else if (!shouldHideELearningListBreadcrumb) {
            listArrBreadCumb.push({
              title: "Eラーニング一覧",
            });
          }
          if (patchName?.[3]) {
            listArrBreadCumb.push({
              title:
                patchName?.[3] === ROUTES.CREATE
                  ? shouldHideELearningListBreadcrumb
                    ? "＋コース新規"
                    : "コース新規"
                  : course_detail_name,
              url: `/${ROUTES.Electronic_Learning}/${ROUTES.COURSES}/${
                patchName?.[3]
              }?${courseBreadcrumbSearchParams.toString()}`,
            });
          }
          return listArrBreadCumb;

        case ROUTES.PROJECT_MANAGER:
          listArrBreadCumb = [
            {
              title: "プロジェクト管理",
              url: `/${ROUTES.PROJECT_MANAGER_LIST}`,
            },
            {
              title: "プロジェクト一覧",
              url: `/${ROUTES.PROJECT_MANAGER_LIST}`,
            },
          ];
          if (isAtPmChartView) {
            listArrBreadCumb.push({
              title: "ガントチャート",
              url: `/${ROUTES.PROJECT_MANAGER_LIST}?pmview=chart`,
            });
          }
          if (patchName?.[2]) {
            listArrBreadCumb.push({
              title: projectDetailData?.name,
            });

            if (patchName?.[3] === "edit") {
              listArrBreadCumb.push({
                title: "編集",
              });
            }

            // When first entering project detail, URL may not have ?pmtab= yet; treat as default tab "project-overview"
            const pmDefaultTab = isAtPmChartView ? "" : "project-overview";
            const pmSubTabParams = searchParams.get("pmsub");
            const hasProgressTabParam =
              pmDetailTabParams === "gantt-chart" ||
              pmDetailTabParams === "progress";

            const effectivePmTab =
              pmDetailTabParams === "gantt-chart"
                ? "progress"
                : pmDetailTabParams || pmDefaultTab;
            if (projectTabTitleMap[effectivePmTab]) {
              listArrBreadCumb.push({
                title: projectTabTitleMap[effectivePmTab],
                url: hasProgressTabParam
                  ? `/${
                      ROUTES.PROJECT_MANAGER_LIST
                    }/${id}?pmtab=progress&pmsub=${
                      pmSubTabParams === "budget-vs-actual" ||
                      pmSubTabParams === "yojitsu"
                        ? "budget-vs-actual"
                        : "gantt-chart"
                    }`
                  : undefined,
              });
            }

            if (patchName?.[3] === "meeting") {
              listArrBreadCumb.push({
                title: "会議一覧",
                url: `/${ROUTES.PROJECT_MANAGER_LIST}/${id}?pmtab=meeting-list`,
              });
              if (patchName?.[4] === "create") {
                listArrBreadCumb.push({
                  title: "進捗会議アジェンダ生成",
                });
              }
              if (patchName?.[5] === "history") {
                listArrBreadCumb.push({
                  title: "履歴",
                });
              }
            }
          }

          if (patchName?.[4]) {
            listArrBreadCumb.push({
              title: patchName?.[5] === "edit" ? "タスク編集" : "タスク詳細",
            });
          }
          return listArrBreadCumb;

        case ROUTES.PROJECT_CHART:
          listArrBreadCumb = [
            {
              title: "プロジェクト管理",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.ADMIN:
          if (patchName.includes(ROUTES.CONFIG)) {
            const fromParam = searchParams.get("from");
            const typeParam = searchParams.get("type");
            const yearParam = searchParams.get("year");

            if (fromParam) {
              const breadcrumb = getSettingCategoriesBreadcrumb(
                fromParam,
                typeParam,
                yearParam,
                false,
              );
              if (breadcrumb) return breadcrumb;
            }

            listArrBreadCumb = [
              {
                title: "運営",
                url: hasCompanyAdminContext
                  ? `/${ROUTES.COMPANIES}`
                  : undefined,
              },
              {
                title: "設定",
                url: `${ROUTES.ADMIN_CONFIG}`,
              },
            ];
            return listArrBreadCumb;
          }
          break;
        case ROUTES.MAINTENANCE_NOTIFICATION:
          listArrBreadCumb = [
            {
              title: "運営",
              url: hasCompanyAdminContext ? `/${ROUTES.COMPANIES}` : undefined,
            },
            {
              title: "メンテナンス通知",
            },
          ];
          return listArrBreadCumb;
        case ROUTES.KPI:
          listArrBreadCumb = [
            {
              title: "予実管理・ＫＰＩ",
              url: `/${ROUTES.KPI}`,
            },
            {
              title: "財務諸表",
            },
          ];
          return listArrBreadCumb;
        case ROUTES.CONTRACT_MANAGEMENT:
          listArrBreadCumb = [
            {
              title: "契約管理",
              url: `/${ROUTES.CONTRACT_MANAGEMENT}`,
            },
          ];
          if (patchName.includes("contract_payment")) {
            listArrBreadCumb = [
              {
                title: "契約管理",
                url: `/${ROUTES.CONTRACT_MANAGEMENT}`,
              },
              {
                title: "見積/契約",
              },
            ];
          }
          if (patchName.includes("payment_history")) {
            listArrBreadCumb = [
              {
                title: "契約管理",
                url: `/${ROUTES.CONTRACT_MANAGEMENT}`,
              },
              {
                title: "見積/契約",
                url: `/${ROUTES.CONTRACT_PAYMENT}`,
              },
              {
                title: "過去の請求記録",
              },
            ];
          }
          if (patchName.includes("staff_list")) {
            listArrBreadCumb = [
              {
                title: "契約管理",
                url: `/${ROUTES.CONTRACT_MANAGEMENT}`,
              },
              {
                title: "見積/契約",
                url: `/${ROUTES.CONTRACT_PAYMENT}`,
              },
              {
                title: "利用スタッフ一覧",
              },
            ];
          }
          return listArrBreadCumb;
        case ROUTES.CORRELATION_DIAGRAM:
          listArrBreadCumb = [
            {
              title: "全機能相関図",
              url: `/${ROUTES.CORRELATION_DIAGRAM}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.ELECTRONIC_LEARNING_CHART:
          listArrBreadCumb = [
            {
              title: "Eラーニング",
              url: `/${ROUTES.ELECTRONIC_LEARNING_CHART}`,
            },
          ];
          return listArrBreadCumb;
        case ROUTES.BUSINESS_RPG:
          listArrBreadCumb = [
            {
              title: "全機能相関図",
              url: `/${ROUTES.CORRELATION_DIAGRAM}`,
            },
            {
              title: "RPG(ビジネス･FIRE)",
              url: `/${ROUTES.BUSINESS_RPG}`,
            },
          ];
          if (patchName?.[2] === "play") {
            listArrBreadCumb.push({
              title: getBusinessRpgPlayLabel(searchParams),
            });
          }
          return listArrBreadCumb;

        case ROUTES.LATEST_TRIAL_BALANCE_FIRE:
          listArrBreadCumb = [
            {
              title: "全機能相関図",
              url: `/${ROUTES.CORRELATION_DIAGRAM}`,
            },
            {
              title: "RPG(ビジネス･FIRE) ",
              url: `/${ROUTES.BUSINESS_RPG}`,
            },
            {
              title:
                patchName?.[2] === ROUTES.DETAIL.replace(/^\//, "")
                  ? "ＦＩＲＥ RPG編集"
                  : "ＦＩＲＥ RPG新規",
            },
          ];
          return listArrBreadCumb;

        case "fire_rpg":
          listArrBreadCumb = [
            {
              title: "全機能相関図",
              url: `/${ROUTES.CORRELATION_DIAGRAM}`,
            },
            {
              title: "ビジネスRPG",
              url: `/${ROUTES.BUSINESS_RPG}`,
            },
          ];
          if (patchName?.[2] === "job_configs") {
            listArrBreadCumb.push({
              title: "(FIRE) 仕事マスタ",
            });
          } else if (patchName?.[2] === "family_events_settings") {
            listArrBreadCumb.push({
              title: "(FIRE)5年毎家庭イベント 設定",
            });
          } else if (
            patchName?.[2] === "market_chart" ||
            patchName?.[2] === "market_table"
          ) {
            listArrBreadCumb.push({
              title: "(FIRE)市場テーブル 設定",
            });
          }
          return listArrBreadCumb;

        case ROUTES.LIST_MESS:
          listArrBreadCumb = [
            {
              title: "カスタマー問合せ",
            },
          ];
          return listArrBreadCumb;

        case ROUTES.SETTING_STATUSES:
        case ROUTES.SETTING_CATEGORIES: {
          const fromParamSC = searchParams.get("from");
          const typeParamSC = searchParams.get("type");
          const yearParamSC = searchParams.get("year");

          if (fromParamSC) {
            const breadcrumb = getSettingCategoriesBreadcrumb(
              fromParamSC,
              typeParamSC,
              yearParamSC,
              true,
            );
            if (breadcrumb) return breadcrumb;
          }
          break;
        }
      }
    };

    const items = getBreadcrumbItems();

    if (size(items) > 0) {
      return [defaultBreadcrumb, ...(items as BreadcrumbItem[])];
    }
    return items;
  };

  const { data: settingSize } = useFetchSettingSize(!!auth);

  const tab = new URLSearchParams(location.search).get("tab");
  const pageMode = new URLSearchParams(location.search).get("pageMode");

  const showDisplaySizeSelector = useMemo(() => {
    return getShowDisplaySizeSelector({
      pathname: location.pathname,
      tab,
      pageMode,
    });
  }, [location.pathname, tab, pageMode]);

  const isDisplayInNewTab = searchParams.get("isDisplayInNewTab") === "true";
  const params = new URLSearchParams(window.location.search);

  const nameCompany = useMemo(() => {
    return (
      auth?.companies.find((company) => company.id.toString() == companyId)
        ?.name ||
      auth?.companies.find((company) => company.is_work_default)?.name
    );
  }, [auth, companyId]);

  const isTwoLines = useMemo((): boolean => {
    if (!nameCompany) return false;
    return (nameCompany as string).length > 15;
  }, [nameCompany]);

  useEffect(() => {
    if (settingSize?.text_scale) {
      dispatch(setDisplaySize({ text_scale: settingSize.text_scale }));
    }
  }, [settingSize?.text_scale, location.pathname, dispatch]);

  useEffect(() => {
    const breadcrumbItems = listBreadCumb();
    const listBreadcumbText = breadcrumbItems?.map((item) => item?.title);

    const title = getTabTitle({
      pathname: location.pathname,
      searchParams,
      breadcrumbItems: listBreadcumbText as string[],
    });
    if (title) {
      document.title = title;
    }
  }, [
    location.pathname,
    location.search,
    searchParams,
    appDetail,
    projectDetailData,
    courseData,
    listOrg,
    projectData,
  ]);
  return (
    <>
      <Container id="app-header">
        <Styles
          columnGap={30}
          // left={isCollapse ? 80 : 240}
          isMobile={isMobileOnly}
          isNewTab={isDisplayInNewTab}
        >
          <div className="container-breadcumb">
            <div
              className="d-flex align-items-center"
              style={{
                justifyContent: "space-between",
                backgroundColor: !isDisplayInNewTab ? "#1E3665" : "transparent",
                ...(isMobileOnly
                  ? {
                      width: "100%",
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                    }
                  : {
                      width: "auto",
                    }),
              }}
            >
              <div
                className="logo-detail-collapse"
                style={
                  isMobileOnly
                    ? {
                        marginLeft: 0,
                        marginRight: 0,
                        display: "flex",
                        cursor: "pointer",
                      }
                    : undefined
                }
                onClick={() => {
                  if (isMobileOnly) dispatch(setIsMobileMenuOpen(true));
                }}
              >
                <div className="d-flex align-item-center">
                  <img
                    src={
                      isDisplayInNewTab ? "/logoBizNewTab.png" : "/logoBiz.png"
                    }
                    alt="logo"
                    height="34"
                  />
                  <CompanyNameWrapper
                    $isTwoLines={isTwoLines}
                    $isNewTab={isDisplayInNewTab}
                  >
                    <Tooltip
                      placement={isMobileOnly ? "bottom" : "right"}
                      title={nameCompany}
                    >
                      <div
                        className="cursor-pointer"
                        style={{
                          whiteSpace: "pre-line",
                          color: isDisplayInNewTab ? "#1E3665" : "#FFFFFF",
                        }}
                      >
                        {formatCompanyName(nameCompany as string | undefined)}
                      </div>
                    </Tooltip>
                  </CompanyNameWrapper>
                </div>
                {!isDisplayInNewTab && !isMobileOnly && (
                  <div className="wrap-button">
                    <ButtonAntd
                      className={`btn-back ${
                        matchCompanyConfig ? "active" : ""
                      }`}
                      onClick={() =>
                        navigate(
                          `/${ROUTES.COMPANY_CONFIGURATION}/${companyId}?tab=${COMPANY_DETAIL_TABS.REGISTRATION_INFO.key}&page_mode=edit`,
                        )
                      }
                      disabled={
                        !permission.isContractStatusAccepted || isUserResigned
                      }
                    >
                      <div className="d-flex flex-col align-item-center justify-content-center my-company-info">
                        <RiBuildingFill size={18} color="#FFFFFF" />
                        企業情報
                      </div>
                    </ButtonAntd>
                  </div>
                )}
              </div>

              {isMobileOnly && (
                <>
                  <CompanyNameWrapper $isTwoLines={isTwoLines}>
                    <Tooltip placement="bottom" title={nameCompany}>
                      <div
                        className="cursor-pointer"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {formatCompanyName(nameCompany as string | undefined)}
                      </div>
                    </Tooltip>
                  </CompanyNameWrapper>
                  <div
                    className="wrap-button"
                    style={{
                      display: "flex",
                      paddingBottom: "8px",
                      alignItems: "flex-end",
                      height: "48px",
                    }}
                  >
                    <Button
                      className={`btn-back ${
                        matchCompanyConfig ? "active" : ""
                      }`}
                      height={20}
                      style={{
                        width: "auto",
                        minWidth: "40px",
                        textAlign: "center",
                        color: "#FFFFFF",
                        border: "1px solid #FFFFFF",
                        borderRadius: "4px",
                        padding: "0px 4px",
                        background: "transparent",
                        fontSize: "12px",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        if (isMobileOnly) {
                          dispatch(setIsMobileMenuOpen(false));
                        }
                        navigate(
                          `/${ROUTES.COMPANY_CONFIGURATION}/${companyId}?tab=${COMPANY_DETAIL_TABS.REGISTRATION_INFO.key}`,
                        );
                      }}
                      label="基本情報"
                      disabled={!permission?.isContractStatusAccepted}
                    />
                  </div>
                </>
              )}
            </div>
            {!isMobileOnly && (
              <div>
                <DisplaySizeSelector
                  defaultValue={settingSize?.text_scale}
                  disabled={!showDisplaySizeSelector}
                />
              </div>
            )}

            {!isMobileOnly && (
              <div className="wrap-breadcumb" ref={wrapRef}>
                {listBreadCumb()?.map(
                  (breadcrumbItem: BreadcrumbItem, idx: number) => {
                    const isCaretRightIcon = [
                      ROUTES.ANNUAL_SALARY_SUMMARIES,
                      ROUTES.CUSTOMER_LIST,
                      ROUTES.ANNUAL_ORG_SUMMARIES,
                    ]?.includes(patchName[1])
                      ? breadcrumbItem?.isShowIcon
                      : idx < size(listBreadCumb()) - 1;
                    const isDefaultBreadcrumb = idx === 0;
                    const isPermissionPage =
                      window.location.pathname ===
                      `/${ROUTES.PERMISSIONS_MANAGEMENT}`;
                    const isPermissionTab = [
                      "Bizシート権限",
                      "給与明細権限",
                      "人事評価権限",
                      "Eラーニング",
                      "企業基礎情報",
                      "社員一覧",
                    ].includes(toString(breadcrumbItem?.title));
                    const isClickablePermission =
                      isPermissionPage && isPermissionTab;

                    const breadcrumbClasses = [
                      "breadcrumb-item",
                      isCaretRightIcon
                        ? "breadcrumb-item-in-active"
                        : "breadcrumb-item-active",
                      isDefaultBreadcrumb
                        ? "border-none background-none margin-top-default-btn"
                        : "border-solid",
                    ].join(" ");

                    return (
                      <React.Fragment key={idx}>
                        {breadcrumbItem?.title && (
                          <div className={breadcrumbClasses}>
                            {breadcrumbItem?.url ? (
                              <Link
                                to={breadcrumbItem.url}
                                onClick={() => {
                                  if (
                                    window.location.pathname ===
                                    breadcrumbItem.url
                                  ) {
                                    // Prevent reload when navigate breadcrumb at the same url with search params
                                    if (window.location.search) {
                                      return;
                                    }
                                    window.location.reload();
                                  }
                                }}
                              >
                                {breadcrumbItem.title}
                              </Link>
                            ) : (
                              <p
                                className={
                                  isClickablePermission ? "clickable" : ""
                                }
                                onClick={() => {
                                  if (isClickablePermission) {
                                    window.location.reload();
                                  }
                                }}
                              >
                                {breadcrumbItem.title}
                              </p>
                            )}
                          </div>
                        )}

                        {isCaretRightIcon && (
                          <span className="wrap-breadcrumb-image-large d-flex align-item-center ml-1 mr-1">
                            {isDefaultBreadcrumb ? (
                              <span
                                style={{
                                  color: "#333333",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                }}
                              >
                                :
                              </span>
                            ) : (
                              <IoMdArrowDropright color="#333333" size={20} />
                            )}
                          </span>
                        )}
                      </React.Fragment>
                    );
                  },
                )}

                <div className="wrap-breadcumb-bonus"></div>

                {isDisplayInNewTab ? (
                  <>
                    {!!listBreadCumb()?.length && (
                      <span className="wrap-breadcrumb-image-large d-flex align-item-center ml-1 mr-1">
                        <IoMdArrowDropright color="#333333" size={20} />
                      </span>
                    )}

                    <Button
                      className="button-work-end"
                      label="作業終了・このタブを閉じる"
                      onClick={closeCurrentTab}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>

          <div className="d-flex align-items-center">
            {!isMobileOnly && !isEmpty(auth) && (
              <Popover
                placement="bottom"
                showArrow={false}
                content={contentMenuRightHeader}
              >
                <div className="d-flex cursor-pointer container-avatar">
                  <div className="avatar">
                    <img
                      src={
                        get(auth, "workers[0].avatar_original_url") ||
                        AvtDefault
                      }
                      alt=""
                    />
                  </div>
                  <div className="d-flex justify-center align-item-center ml-1">
                    <RiArrowDownSFill size={28} color="#1E3665" />
                  </div>
                </div>
              </Popover>
            )}
          </div>
        </Styles>
      </Container>
      <ModalSelectEdit isOpen={isOpenModal} handleCancel={handleCancelModal} />
    </>
  );
};

export default Header;
